const AUTH_STORAGE_KEY = 'accounting.auth';

export const getStoredAuth = () => {
    const value = sessionStorage.getItem(AUTH_STORAGE_KEY);
    return value || null;
};

export const buildBasicAuthToken = (userName, password) => {
    return window.btoa(`${userName}:${password}`);
};

export const setStoredAuth = (token) => {
    sessionStorage.setItem(AUTH_STORAGE_KEY, token);
};

export const clearStoredAuth = () => {
    sessionStorage.removeItem(AUTH_STORAGE_KEY);
};

export const isAuthenticated = () => {
    return !!getStoredAuth();
};
